var map = {
	"./about/index.js": 351,
	"./cart/index.js": 352,
	"./checkout/index.js": 353,
	"./contact/index.js": 362,
	"./footer.js": 96,
	"./galleries/index.js": 363,
	"./header.js": 136,
	"./index.js": 364,
	"./main.js": 133,
	"./products/category/index.js": 366,
	"./products/index.js": 367,
	"./products/purchase/index.js": 368,
	"./search/index.js": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 350;